import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-669dcee3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "upload-license-form",
  class: "login-content upload-license--container"
}
const _hoisted_2 = { class: "ibf-h1-larger login-title" }
const _hoisted_3 = { class: "login-subtitle" }
const _hoisted_4 = { class: "login-form items-center" }
const _hoisted_5 = { class: "row w-[306px]" }
const _hoisted_6 = { class: "h-[156px]" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_8 = {
  id: "login-support-link",
  class: "mt-[28px] underline"
}
const _hoisted_9 = ["href"]

import { IncrediButton, IncrediNote } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { inject, ref } from 'vue';
import { useRouter } from 'vue-router';
// import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { CommonDataDocument, License_Action_Activate_AsyncDocument } from '@/graphql/codegen/generated/graphql';
import { licenseStatesCodes } from '@/const/licensePage';
import apolloClient from '@/plugins/GraphQL/Apollo/client';
import { longPolling } from '@/services/PlatfromGQL/longPolling';
import UploadFile from '@/components/common/uploadFile/uploadFIle.vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { Routes } from '@/router/router.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'uploadLicenseForm',
  emits: ["backButton", "showLoading"],
  setup(__props, { emit }: { emit: ({ (e: 'backButton'): void; (e: 'showLoading', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const supportMailUrl = ref(process.env.VUE_APP_SUPPORT_MAIL);

const showErrorNote = ref(false);
const router = useRouter();
const coordinatorsService = inject(IKCoordinatorsService);

const handleLicenseFileUploadResult = async (state: licenseStatesCodes | undefined) => {
  if (state === licenseStatesCodes.Active) {
    // refresh common data to get the new license state for the navigation guards
    await apolloClient.query({
      query: CommonDataDocument,
      variables: {
        coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
      },
      fetchPolicy: 'network-only',
    });

    await router.push({ name: Routes.Home });
  } else {
    showErrorNote.value = true;
  }
};

const uploadLicenseFile = async (base64Content: string) => {
  try {
    emit('showLoading', true);
    const activatePollingId = await apolloClient.mutate({
      mutation: License_Action_Activate_AsyncDocument,
      variables: {
        licenseKey: base64Content,
      },
    });
    const results = await longPolling.fetch('license_action_asyncResult', activatePollingId?.data?.license_action_activate_async);
    const state = results?.data?.license_action_asyncResult?.result?.state;

    await handleLicenseFileUploadResult(state);
  } catch (e) {
    showErrorNote.value = true;
  } finally {
    emit('showLoading', false);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.uploadLicenseForm.title')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.uploadLicenseForm.subtitle')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(UploadFile, {
              class: "mt-8",
              "upload-file-callback": uploadLicenseFile
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            (showErrorNote.value)
              ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                  key: 0,
                  type: "Error",
                  class: "mt-[32px] w-[306px]"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.loginForm.licenseUploadFlow.error')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(IncrediButton), {
              "data-testid": "upload-license-form--back-button",
              size: "big",
              class: "w-[306px] !rounded-[50px] block !h-[40px] !bg-Hovers/hover_grey !text-Text/text_high",
              design: "primary-green",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => emit('backButton'), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              "data-testid": "upload-license-form--support-link",
              tabindex: "4",
              href: supportMailUrl.value
            }, _toDisplayString(_ctx.$t('login.licenseForm.supportLink')), 9, _hoisted_9)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})